/**
 * created 14.10.2025
 */
import React from 'react';
import type {PropsWithChildren} from 'react';

// A simple container that places the provided screenshot under a decorative frame image
// The frame image defines the rendered size; the screenshot is positioned inside with padding.

type ScreenshotContainerComponentType = PropsWithChildren<{
  screenshotUrl: string;
  // optional tweaking if needed by callers
  className?: string;
  style?: React.CSSProperties;
}>

const containerFrame = '/images/titanium-frame1.png';

export function ScreenshotContainer({ screenshotUrl, className, style }: ScreenshotContainerComponentType) {
  const PADDING_PERCENT = 6; // inner padding so the screenshot sits nicely within the frame

  return (
    <div
      className={className}
      style={{
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        // Height is driven by the frame image below; keep any optional external styles too
        ...style,
      }}
    >
      {/* Screenshot underneath */}
      <img
        src={screenshotUrl}
        alt="Course screenshot"
        style={{
          position: 'absolute',
          top: `${PADDING_PERCENT}%`,
          left: `${PADDING_PERCENT}%`,
          right: `${PADDING_PERCENT}%`,
          bottom: `${PADDING_PERCENT}%`,
          width: `calc(100% - ${PADDING_PERCENT * 2}%)`,
          height: `calc(100% - ${PADDING_PERCENT *2}%)`,
          objectFit: 'fill',
          borderRadius: 14,
          // boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
      />

      {/* Frame on top so it visually sits above the screenshot */}
      <img
        src={containerFrame}
        alt="Device frame"
        style={{
          display: 'block',
          width: '100%',
          height: 'auto',
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      />
    </div>
  );
}
